import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { DataClassificationEnabledQuery } from '../queries/DataClassificationEnabled.graphql';

// hook to determine if data classification is enabled for org
export const useIsDataClassificationEnabledForOrg = ({ skip = false }: { skip?: boolean } = {}) => {
	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { data, error, loading } = useQuery(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
		DataClassificationEnabledQuery,
		{
			context: { single: true },
			skip,
		},
	);

	const isEnabled = Boolean(data?.isDataClassificationEnabled);

	return { isEnabled, error, loading };
};
